export class GlueCatalogProperties {
    'region';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GlueCatalogProperties.attributeTypeMap;
    }
    constructor() {
    }
}
